export interface CatalogueClient {
  id: string; // id_client (ERP)
  name: string;
  prismeClientId?: number;
}

export interface CatalogueAsset {
  id: string;
  name: string;
  parentDependencies: string[];
  childDependencies: string[];
}

export interface CatalogueGroup {
  id: number | string;
  idClient?: number;
  level: number;
  name: string;
  description?: string;
  assetsCount?: number;
  assets: CatalogueAsset[];
}

const API_BASE = '/api/prisme/catalogue-actifs';

export async function getCatalogueClients(): Promise<CatalogueClient[]> {
  const res = await fetch(`${API_BASE}/clients`, { credentials: 'include' });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(error.error || 'Erreur chargement clients catalogue');
  }
  return await res.json();
}

export async function getCatalogueForClient(idClientErp: string): Promise<CatalogueGroup[]> {
  const res = await fetch(`${API_BASE}/${encodeURIComponent(idClientErp)}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    const error = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(error.error || 'Erreur chargement catalogue actifs');
  }
  const data = await res.json();
  return data.groups || [];
}

